module.exports = __webpack_public_path__ + "img/carbini-icon.65230949.svg";